import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class BranchAreaCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bohUsers: [],
      pricingAreas: [],
      isLoading: false,
      generalManagerUsers: [],
    };
  }

  componentDidMount() {
    this.fetchAreaPricing();
    this.fetchBOH();
    this.fetchGM();
  }

  async fetchAreaPricing() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-pricing`);
    this.setState({ pricingAreas: areas });
  }

  async fetchBOH() {
    const {
      data: { bohUsers },
    } = await axios.get(`/misc/boh-users`);
    this.setState({ bohUsers });
  }

  async fetchGM() {
    const {
      data: { generalManagerUsers },
    } = await axios.get(`/misc/general-manager-users`);
    this.setState({ generalManagerUsers });
  }

  async createBranchArea(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        axios
          .post(`/admin-panel/branch-area`, values)
          .then((result) => {
            message.success(`Berhasil menambah Area ${values.name}`);
            this.props.history.push(`/home/branch-area`);
          })
          .catch((err) => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Create Area");
      }
    } else {
      message.error("Error Create Area");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Create Branch Area">
        <Spin
          tip="Sedang menambahkan Area Baru"
          spinning={this.state.isLoading}>
          <Form onSubmit={(e) => this.createBranchArea(e)}>
            <FormItem label="Area">
              {getFieldDecorator("name", {
                rules: [{ required: true, message: "Area wajib diisi" }],
              })(<Input />)}
            </FormItem>
            <FormItem label="Branch Internal">
              {getFieldDecorator("internalBranch", {
                rules: [
                  { required: true, message: "Branch Internal wajib diisi" },
                ],
              })(<Input />)}
            </FormItem>
            <FormItem label="Branch Code">
              {getFieldDecorator("codeBranch", {
                rules: [{ required: true, message: "Branch Code wajib diisi" }],
              })(<Input />)}
            </FormItem>

            <FormItem label="Pricing Area">
              {getFieldDecorator("areaPricingId", {
                initialValue: this.state.pricingAreas[0]
                  ? this.state.pricingAreas[0].id
                  : "",
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a Pricing Area">
                  {this.state.pricingAreas.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem label="BOH">
              {getFieldDecorator("userId")(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a BOH">
                  {this.state.bohUsers.map((val, index) => (
                    <Option key={index} value={val.userId}>
                      {val.User ? val.User.name : ""}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem label="General Master">
              {getFieldDecorator("gmId")(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a General Master">
                  {this.state.generalManagerUsers.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val ? val.name : ""}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Create
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(BranchAreaCreate);



// WEBPACK FOOTER //
// src/components/Dashboard/Area/BranchArea/BranchAreaCreate.js